import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class TerminologyService extends ApiService {
  namespace = "company-settings";
  icon = "Wrench";
  name = "Terminology";
  DOMAIN = DOMAIN.COMPANY_SETTING;
  favicon = "Wrench";
  Width = 690;
  action = "action";

  loaderIconNode(endpoint){
    this.buildEndPoint("site/loader-icon")
  }
  constructor() {
    super("site/settings");
  }
}
